module.exports = __webpack_public_path__ + "r-v3/img/more_vertical_gray.e1fe5a0f.svg";